<app-modal-box [title]="resultado() ? 'Resultado del control' : 'Recepción de caja'"
    [subtitle]="resultado() ? 'Así quedó el control de este cambio de turno.' : 'Contá lo que recibís para empezar tu turno.'">
    <ng-template #headerTemplate>
        @if (!resultado()) {
            <div class="bg-amber-50 p-4 rounded-2xl border border-amber-100 text-sm text-amber-900 mb-4">
                <b>{{ data.pendiente.handed_by_name }}</b> entregó la caja a las {{ data.pendiente.initiated_at | date:'HH:mm' }}.
                Contá el efectivo y cada medio de pago. Cuando termines, el sistema te muestra si coincide.
            </div>
        }
    </ng-template>

    <ng-template #bodyTemplate>
        @if (resultado(); as res) {
            <div class="flex flex-col gap-5">
                <div class="overflow-x-auto rounded-2xl border border-slate-100">
                    <table class="w-full text-sm">
                        <thead>
                            <tr class="text-left text-[10px] font-black text-slate-400 uppercase tracking-widest">
                                <th class="px-4 py-3">Medio</th>
                                <th class="px-4 py-3 text-right">Según el sistema</th>
                                <th class="px-4 py-3 text-right">Dejó {{ data.pendiente.handed_by_name }}</th>
                                <th class="px-4 py-3 text-right">Contaste vos</th>
                                <th class="px-4 py-3">Resultado</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (fila of filas(); track fila.clave) {
                                <tr class="border-t border-slate-100">
                                    <td class="px-4 py-3 font-semibold text-slate-700">{{ fila.nombre }}</td>
                                    <td class="px-4 py-3 text-right text-slate-600">{{ fila.sistema | currency:'ARS' }}</td>
                                    <td class="px-4 py-3 text-right text-slate-600">{{ fila.dejado | currency:'ARS' }}</td>
                                    <td class="px-4 py-3 text-right font-black text-slate-800">{{ fila.contado | currency:'ARS' }}</td>
                                    <td class="px-4 py-3">
                                        @switch (fila.tipo) {
                                            @case ('coincide') {
                                                <span class="px-2.5 py-1 rounded-full text-xs font-bold bg-emerald-50 text-emerald-700">Coincide</span>
                                            }
                                            @case ('dif_sistema') {
                                                <span class="px-2.5 py-1 rounded-full text-xs font-bold whitespace-nowrap"
                                                      [ngClass]="fila.diferencia < 0 ? 'bg-rose-50 text-rose-700' : 'bg-amber-50 text-amber-700'">
                                                    {{ fila.diferencia | currency:'ARS' }} vs sistema
                                                </span>
                                            }
                                            @default {
                                                <span class="px-2.5 py-1 rounded-full text-xs font-bold bg-amber-50 text-amber-700 whitespace-nowrap">Distinto a lo entregado</span>
                                            }
                                        }
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>

                @if (diferencias() === 0) {
                    <div class="flex items-center gap-3 p-4 rounded-2xl bg-emerald-50 text-emerald-700">
                        <mat-icon class="shrink-0">check_circle</mat-icon>
                        <span class="text-sm font-bold">Todo coincide. Podés empezar tu turno.</span>
                    </div>
                } @else {
                    <div class="flex items-center gap-3 p-4 rounded-2xl bg-amber-50 text-amber-800">
                        <mat-icon class="shrink-0">warning</mat-icon>
                        <span class="text-sm font-bold">
                            Hay {{ diferencias() }} {{ diferencias() === 1 ? 'diferencia' : 'diferencias' }}. Queda registrada y podés seguir trabajando.
                        </span>
                    </div>
                }
            </div>
        } @else {
            <div class="flex flex-col gap-5">
                @if (pideVendedora()) {
                    <div class="flex flex-col gap-1.5">
                        <label class="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Vendedor que recibe la caja</label>
                        <mat-form-field appearance="outline" class="w-full custom-field" subscriptSizing="dynamic">
                            <mat-select [value]="vendedoraId()" (selectionChange)="vendedoraId.set($event.value)" placeholder="Seleccioná quién recibe" [disabled]="guardando()" id="reception-seller-select">
                                <mat-select-trigger>
                                    <span class="font-bold text-slate-800">{{ vendedoraNombre() }}</span>
                                </mat-select-trigger>
                                @for (vendedora of vendedorasDisponibles(); track vendedora.id) {
                                    <mat-option [value]="vendedora.id">{{ vendedora.name }}</mat-option>
                                }
                            </mat-select>
                            <mat-icon matPrefix class="text-slate-400 mx-2">badge</mat-icon>
                        </mat-form-field>
                    </div>
                }

                <div class="flex flex-col gap-1.5">
                    <label class="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Efectivo contado en el cajón</label>
                    <mat-form-field appearance="outline" class="w-full custom-field" subscriptSizing="dynamic">
                        <span matPrefix class="px-3 text-slate-400 font-bold">$</span>
                        <input matInput type="number" min="0" [ngModel]="contado()" (ngModelChange)="contado.set($event === '' ? null : $event)" placeholder="0.00" [disabled]="guardando()" id="reception-counted-input">
                    </mat-form-field>
                </div>

                @if (conteos().length > 0) {
                    <div class="flex flex-col gap-3 p-4 rounded-2xl bg-slate-50 border border-slate-200/60">
                        <div class="flex flex-col gap-0.5">
                            <span class="text-xs font-black text-slate-600 uppercase tracking-wider">Verificación por Medio de Pago</span>
                            <span class="text-[11px] text-slate-400 font-medium">Ingresá lo que ves en la plataforma real (posnet, app de cobro, etc.) de cada medio.</span>
                        </div>
                        @for (conteo of conteos(); track conteo.key; let i = $index) {
                            <div class="flex flex-col gap-1.5 p-3 rounded-xl bg-white border border-slate-100">
                                <span class="text-sm font-bold text-slate-700">{{ conteo.name }}</span>
                                <mat-form-field appearance="outline" class="w-full custom-field" subscriptSizing="dynamic">
                                    <span matPrefix class="px-3 text-slate-400 font-bold">$</span>
                                    <input matInput type="number" min="0" [ngModel]="conteo.monto" (ngModelChange)="cambiarMonto(i, $event === '' ? null : $event)" [disabled]="guardando()" placeholder="0.00">
                                </mat-form-field>
                            </div>
                        }
                    </div>
                }

                <div class="flex flex-col gap-1.5">
                    <label class="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Comentarios (Opcional)</label>
                    <mat-form-field appearance="outline" class="w-full custom-field" subscriptSizing="dynamic">
                        <textarea matInput [ngModel]="notas()" (ngModelChange)="notas.set($event)" [disabled]="guardando()" rows="2" placeholder="Aclaraciones..." id="reception-notes-input"></textarea>
                    </mat-form-field>
                </div>
            </div>
        }
    </ng-template>

    <ng-template #footerTemplate>
        @if (resultado()) {
            <button mat-flat-button color="primary" class="btn-primary-add" (click)="cerrar()" id="reception-finish-btn">Empezar mi turno</button>
        } @else {
            <button mat-button type="button" class="btn-secondary-back" [disabled]="guardando()" (click)="cerrar()" id="reception-cancel-btn">Cancelar</button>
            <button mat-flat-button color="primary" class="btn-primary-add" [disabled]="!puedeControlar()" (click)="controlar()" id="reception-confirm-btn">
                @if (guardando()) {
                    <span class="flex items-center gap-2">
                        <mat-spinner diameter="18"></mat-spinner>
                        Procesando...
                    </span>
                } @else {
                    Controlar caja
                }
            </button>
        }
    </ng-template>
</app-modal-box>
